import actionTypes from '../constants/actionTypes';
import {DARK_THEME} from '../constants';
import _ from 'lodash';
import transcriptions from '../constants/transcriptions.json';
import translations from '../constants/translations.json';
import speechClient from '../containers/Subtitles/speechClient';

// Initial states
const defaultAccessToken = getDefaultAccessToken();
const defaultExpiresAt = localStorage.getItem('expiresAt');
const defaultStripeCustomer = {};
const defaultProfile = {};
const defaultIsProfileSynced = false;
const defaultIsCustomerSynced = false;
const defaultAlert = {type: null, message: null};
const defaultTheme = DARK_THEME;
const defaultFontSize = 20;
const defaultTranscription = getDefaultTranscription();
const defaultTranslation = getDefaultTranslation();

function getDefaultAccessToken() {
  const accessToken = localStorage.getItem('accessToken');
  speechClient.setAccessToken(accessToken);
  return accessToken;
}

function getDefaultTranscription() {
  const transcription = JSON.parse(localStorage.getItem('transcription'));
  const fallback = _.find(transcriptions, {language: 'en-US'}, {});
  const defaultTranscription = transcription || fallback;
  speechClient.setTranscriptionLanguage(defaultTranscription);
  return defaultTranscription;
}

function getDefaultTranslation() {
  const translation = JSON.parse(localStorage.getItem('translation'));
  const fallback = _.find(translations, {language: 'fr'}, {});
  const defaultTranslation = translation || fallback;
  speechClient.setTranslationLanguage(defaultTranslation);
  return defaultTranslation;
}

// Reducers
const accessTokenReducer = (state = defaultAccessToken, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SESSION:
      speechClient.setAccessToken(action.payload.accessToken);
      return action.payload.accessToken;
    default:
      return state;
  }
};

const expiresAtReducer = (state = defaultExpiresAt, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SESSION:
      return action.payload.expiresAt;
    default:
      return state;
  }
};

const customerReducer = (state = defaultStripeCustomer, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CUSTOMER:
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};

const profileReducer = (state = defaultProfile, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PROFILE:
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};

const isProfileSyncedReducer = (state = defaultIsProfileSynced, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_IS_PROFILE_SYNCED:
      return action.payload;
    default:
      return state;
  }
};

const isCustomerSyncedReducer = (state = defaultIsCustomerSynced, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_IS_CUSTOMER_SYNCED:
      return action.payload;
    default:
      return state;
  }
};

const alertReducer = (state = defaultAlert, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ALERT:
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};

const themeReducer = (state = defaultTheme, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_THEME:
      return action.payload;
    default:
      return state;
  }
};

const fontSizeReducer = (state = defaultFontSize, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_FONT_SIZE:
      return action.payload;
    default:
      return state;
  }
};

const transcriptionReducer = (state = defaultTranscription, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TRANSCRIPTION:
      localStorage.setItem('transcription', JSON.stringify(action.payload));
      speechClient.setTranscriptionLanguage(action.payload);
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};

const translationReducer = (state = defaultTranslation, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TRANSLATION:
      localStorage.setItem('translation', JSON.stringify(action.payload));
      speechClient.setTranslationLanguage(action.payload);
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};


const reducers = {
  accessToken: accessTokenReducer,
  expiresAt: expiresAtReducer,
  customer: customerReducer,
  profile: profileReducer,
  isProfileSynced: isProfileSyncedReducer,
  isCustomerSynced: isCustomerSyncedReducer,
  alert: alertReducer,
  theme: themeReducer,
  fontSize: fontSizeReducer,
  transcription: transcriptionReducer,
  translation: translationReducer
};

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js